/**
 * Created by sunshine on 2016/12/27.
 */
/*eslint-disable*/
let apiLinks

// dev发环境 http://yc.yonyou.com 360 账号为ycwyg56
// B环境 wuyanguo 1219
// 正式环境 https://yc.yonyoucloud.com
// ================= 需要修改的部分 =================//
let yc = window.location.protocol + '//' + window.location.host
// 后台提供
let enterpriseId = 83668

let tenantid = 'ohdwuk32'
// 用ys_cgs测试用
// tenantid = 'h050u1t9'
// slogan
let slogan = ''
let logourl = 'static/imgs/logo.png'
// 公司名字
let companyname = '上海浦东国际机场货运站有限公司'
let companyfullname = '上海浦东国际机场货运站有限公司'
// 公司官网
let companyHomePage = 'http://www.pactl.com.cn/cn/index.html'
// 联系我们页面
let companyContactUs = 'http://www.aotecar.com/contact/&columnsId=55&FrontColumns_navigation01-1404201334910345678FirstColumnId=55.html'
// 分支名字或访问context
let portaltype = 'pactl'

let bannerList = [
  {
    class: 'carousel-bg-jsqp2'
  }
]
// 联系电话
let telephone = '+86 021-68842008-1403'
let address = '上海市浦东新区速航路168号'
let servicetime = '周一至周五 上午08:30至下午17:30'
// ================= 需要修改的部分 =================//
apiLinks = {
  logourl: logourl,
  address: address,
  companyfullname: companyfullname,
  telephone: telephone,
  servicetime: servicetime,
  companyname: companyname,
  context: portaltype,
  bannerList: bannerList,
  slogan: slogan,
  companyContactUs: companyContactUs,
  selfHome: companyHomePage,
  welcome: '您好，欢迎来到“' + companyname + '”采购门户！',
  portaltype: portaltype,
  // materiaClass: yc + '/yuncai/jsonp/pubmaterialClass?enterpriseId=' + enterpriseId,
  materiaClass: yc + '/yuncai/jsonp/getMaterialClass?enterpriseId=' + enterpriseId + '&parentId=',
  orgClass: yc + '/yuncai/org/getorgbydef?pageIndex=0&pageSize=100&org_type=2&org_types=0&enterprise_id=' + enterpriseId,
  southCement: {
    home: companyHomePage
  },
  caslogout: '/yuncai/caslogout',
  // 注册页面
  register: yc + '/yuncai/privateportal#/pages/supplymgr/supplyapplyregister?purentid=' + enterpriseId + '&agree=1&ipuid=' + portaltype,
  // 进入工作台/注册
  enterWorkbench: yc + '/workbench/sso/login.jsp',
  // 供应商申请
  suppliersFor: yc + "/cpu-portal-fe/portalcas.html#/pages/supplymgr/addSupplyApply?purentid=" + enterpriseId + "&ipuid=" + portaltype + "&v=" + Date.parse(new Date().toLocaleDateString()),
  // 首页左侧数据相关链接
  infoTable: {
    latest: [
      yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=allNotice&supEnterpriseIds=' + enterpriseId + '&status=4&pageIndex=0&pageSize=6',
      'latest2',
      'latest3'
    ],
    area: [
      yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=allNotice&supEnterpriseIds=' + enterpriseId + '&status=4&pageIndex=0&pageSize=6',
      'area2',
      'area3',
      'area4',
      'area5',
      'area6',
      'area7',
      'area8'
    ],
    type: [
      yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=allNotice&supEnterpriseIds=' + enterpriseId + '&status=4&pageIndex=0&pageSize=6',
      '2',
      '3',
      '4'
    ]
  },
  // 物资招标公告链接(之后封装成一个对象目前只有两个)
  purchasetableDate: [
    // 询价公告
    yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=purchase&supEnterpriseIds=' + enterpriseId + '&status=0&pageSize=10&pageIndex=0',
    // 招标公告
    yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=purchase&supEnterpriseIds=' + enterpriseId + '&status=4&pageSize=10&pageIndex=0',
    // 中标公告
    yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=purchase&supEnterpriseIds=' + enterpriseId + '&status=10&pageSize=10&pageIndex=0',
    // 竞价公告
    '',
    // 竞价性谈判
    ''
  ],
  // 物流招标公告链接
  logisticstableDate: [
    // 询价公告
    '',
    // 招标公告
    yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=logistics&supEnterpriseIds=' + enterpriseId + '&status=6&pageSize=10&pageIndex=0',
    // 中标公告
    yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=logistics&supEnterpriseIds=' + enterpriseId + '&status=7&pageSize=10&pageIndex=0',
    // 竞价公告
    '',
    // 竞价性谈判
    ''
  ],
  // 工程招标公告链接
  logisticsestableDate: [
    // 询价公告
    '',
    // 招标公告
    yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=logistics&supEnterpriseIds=' + enterpriseId + '&status=11&pageSize=10&pageIndex=0',
    // 中标公告
    yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=logistics&supEnterpriseIds=' + enterpriseId + '&status=13&pageSize=10&pageIndex=0'
  ],
  // 服务招标公告链接
  engineeringtableDate: [
    // 询价公告
    '',
    // 招标公告
    yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=logistics&supEnterpriseIds=' + enterpriseId + '&status=12&pageSize=10&pageIndex=0',
    // 中标公告
    yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=logistics&supEnterpriseIds=' + enterpriseId + '&status=14&pageSize=10&pageIndex=0'
  ],
  // 查看详情不同status跳转页面 bidDetails: cpu-fe-bid -> cpu-fe-tender
  details: {
    bidDoc: yc + '/cpu-fe-bid/dist/bidddocread/index.html?type=1&id=',
    bidDetails: yc + '/cpu-fe-tender/dist/supplyenlistshowother/index.html?show=1&id=',
    bidNotice: yc + '/cpu-portal-fe/portalcas.html#/pages/pricedecision/pricedecisionnotice_publish?id=',
    bidMsg: yc + '/cpu-fe-bid/dist/submitbidnotice/index.html?type=3&id=',
    bidMsg2: yc + '/cpu-portal-fe/portalcas.html#/pages/pricedecision/pricedecisionnotice_publish?id=',
    // 竞价招标公告
    bidMsg3: yc + '/cpu-bidauction-fe/bidNotificationPublic/index.zh_CN.html?id=',
    inquiryDetails: yc + '/cpu-fe-tender/dist/inquirydetail/index.html?id=',
    company: yc + '/gwmanage/pages/notice/detail.html?id=',
    noticeMore: yc + '/cpu-dashboard-fe/index.html#/anoucementlist?tenantid=' + tenantid,
    lbnoticeMore: yc + '/cpu-dashboard-fe/index.html#/noticelist?supEnterpriseId=' + enterpriseId + '&status=18',
    cqnoticeMore: yc + '/cpu-dashboard-fe/index.html#/noticelist?supEnterpriseId=' + enterpriseId + '&status=19',
    lbNotice: yc + '/cpu-fe-bid/dist/lbnotice/index.html?id=',//流标公告
    cqNotice: yc + '/cpu-fe-bid/dist/clarifynotice/index.html?id='//澄清公告
  },
  notice: {
    company: '/gwmanage/pub/notice/entnotice?tenantid=' + tenantid + '&pageIndex=1&pageSize=6&key=',
    bidding: yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=allBidNotice&supEnterpriseIds=' + enterpriseId + '&status=5&pageSize=6&pageIndex=0',
    clarify: '',
    lbnotice: yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=purchase&supEnterpriseIds=' + enterpriseId + '&status=18&pageIndex=0&pageSize=6',
    cqnotice: yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=purchase&supEnterpriseIds=' + enterpriseId + '&status=19&pageIndex=0&pageSize=6'
  },
  // 联系我们页面
  contact: yc + '/cpu-project-def/ycctrl/projectdef/getBidCountInfo?enterpriseId=' + enterpriseId,
  // 是否已申请过供应商
  agreement: yc + '/cpu-supplymgr/supplyApply/isExistApply?purEntId=' + enterpriseId
}
export { apiLinks }



// WEBPACK FOOTER //
// ./src/api/links.js